var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsDownChatbotReportsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.0006 12.0807L6.66727 9.33398H2.7806C2.57361 9.33398 2.36945 9.28579 2.18431 9.19322C1.99917 9.10065 1.83813 8.96625 1.71393 8.80065C1.58974 8.63506 1.5058 8.44282 1.46877 8.23916C1.43174 8.03551 1.44264 7.82603 1.5006 7.62732L3.05393 2.29398C3.13471 2.01703 3.30314 1.77375 3.53393 1.60065C3.76473 1.42755 4.04544 1.33398 4.33393 1.33398H13.3339C13.6876 1.33398 14.0267 1.47446 14.2767 1.72451C14.5268 1.97456 14.6673 2.3137 14.6673 2.66732V8.00065C14.6673 8.35427 14.5268 8.69341 14.2767 8.94346C14.0267 9.19351 13.6876 9.33398 13.3339 9.33398H11.4939C11.2459 9.33412 11.0028 9.40344 10.792 9.53417C10.5811 9.6649 10.411 9.85184 10.3006 10.074L8.0006 14.6673C7.68621 14.6634 7.37677 14.5885 7.0954 14.4483C6.81402 14.308 6.56798 14.1059 6.37566 13.8572C6.18335 13.6085 6.04972 13.3195 5.98477 13.0118C5.91983 12.7042 5.92524 12.3859 6.0006 12.0807Z",
    stroke: "#8D8D8D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.334 9.33398V1.33398",
    stroke: "#8D8D8D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDownChatbotReportsIcon);
export default __webpack_public_path__ + "static/media/ThumbsDownChatbotReportsIcon.dc140f93348feef0cfeb14291814d0aa.svg";
export { ForwardRef as ReactComponent };